import { trackEvent } from "@lib/infrastructure";
import { HaNContext, type HaNNodeSelection } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { type HaNResult, useOpenResult } from "./useOpenResult";

/** Opens a result suggested on the floor above or below, which also counts as following the suggestion. */
export const useOpenSuggestedResult = () => {
  const { tab, building } = useRequiredContext(HaNContext);
  const openResult = useOpenResult();

  return (kind: HaNNodeSelection["kind"], result: HaNResult, direction: "above" | "below") => {
    openResult(kind, result, {
      onOpened: () => {
        trackEvent("HereAndNow_OtherFloorSuggestions__SuggestionClick", {
          buildingId: building.buildingId ?? "",
          tab,
          floorId: result.floorId,
          type: direction,
          nodeId: result.id,
        });
      },
    });
  };
};
